import { Add } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import backIcon from "./../../images/back-icon.svg";
import { useStyles } from "./styles";

const SimpleWidgetsHeader = ({ onClose, title, Icon, action }) => {
    const classes = useStyles();

    return (
        <div className={classes.Header}>
            {onClose && (
                <IconButton onClick={() => onClose?.()} className="BackBtn">
                    <img src={backIcon} />
                </IconButton>
            )}
            <div className={classes.Details}>
                <div className="HeaderIcon"> {Icon && <Icon />}</div>
                <div className="HeaderTitle">
                    <div>{title}</div>
                </div>
                {action && (
                    <IconButton onClick={action.callback}>
                        {action.Icon ? <action.Icon /> : <Add />}
                    </IconButton>
                )}
            </div>
        </div>
    );
};

export default SimpleWidgetsHeader;
